import * as React from "react";
import { Blockquote, BlockquoteAuthor } from "./blockquote";

export function BlockquoteDemo() {
  return (
    <Blockquote>
      The only way to do great work is to love what you do. If you haven't found
      it yet, keep looking. Don't settle.
      <BlockquoteAuthor>Steve Jobs</BlockquoteAuthor>
    </Blockquote>
  );
}
